module.exports = __webpack_public_path__ + "img/spacing-example-simple-details-5.59af43df.png";